module.exports = __webpack_public_path__ + "static/media/lizScene-03.16ae4f86.jpg";